module.exports = __webpack_public_path__ + "img/licorice.b234f4c0.png";